import { useContext } from "react";
import { Context } from "../../context/context";
import SimulationsTable from "../../components/Tables/SimulationsTable/SimulationsTable";

export default function Simulations() {
  const { sidebar } = useContext(Context);

  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <h1>Simulações</h1>
        <div className="table-container">
          <SimulationsTable />
        </div>
      </main>
    </>
  );
}
